import api from '@/api'

const SET_ITEMS = 'SET_ITEMS'
const ADD_ITEM = 'ADD_ITEM'
const UPDATE_ITEM = 'UPDATE_ITEM'

const SET_CURRENT_FARM = 'SET_CURRENT_FARM'

export default {
  namespaced: true,

  state () {
    return {
      items: [],
      currentFarm: null
    }
  },

  getters: {
    farms: (state) => state.items,
    currentFarm: (state) => state.currentFarm
  },

  mutations: {
    [SET_ITEMS] (state, data) {
      state.items = data
    },

    [ADD_ITEM] (state, data) {
      state.items.push(data)
    },

    [UPDATE_ITEM] (state, data) {
      const index = state.items
        .map(item => item.id)
        .indexOf(data.id)
      if (index !== -1) {
        for (const field in data) {
          state.items[index][field] = data[field]
        }
      }
    },

    [SET_CURRENT_FARM] (state, data) {
      state.currentFarm = data
    }
  },

  actions: {
    async loadFarms ({ commit }) {
      const { data } = await api.farms.list()
      commit(SET_ITEMS, data || [])
      return data
    },
    async loadFarmsV2 ({ commit }, payload) {
      const { data } = await api.farms.listV2(payload)
      commit(SET_ITEMS, data || [])
      return data
    },

    async getFarm ({ commit }, id) {
      const { data } = await api.farms.getById(id)
      commit(SET_CURRENT_FARM, data)
      return data
    }
  }
}
